import { tvpil } from '../compat/tvpil';

import { getContinueWatchingSettings } from './getContinueWatchingSettings';
import { prefetchContinueWatchingQuery } from './queries';

export function prefetchContinueWatching({ pageSize, referenceId }: { pageSize: number; referenceId: string }) {
  const category = tvpil.categoryTreeItemsMap.get(referenceId);

  if (!category) {
    return Promise.resolve();
  }

  const settings = getContinueWatchingSettings(category);

  return prefetchContinueWatchingQuery({ pageSize, referenceId, settings });
}
